import React from 'react';
import { ReactSortable } from 'react-sortablejs';

import { PromoUploadStatusType } from '@entities/adCampaign';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { ELEMENT_IDS } from './consts';
import ExactTimeMediaUploaderItem from './ExactTimeMediaUploaderItem';
import itemStyles from './ExactTimeMediaUploaderItem/index.module.scss';
import styles from './index.module.scss';
import { TEXTS } from '../texts';
import { ExactTimeMediaUploaderProps } from './types';

const ExactTimeMediaUploader: React.FC<ExactTimeMediaUploaderProps> = ({
  mediaType,
  acceptValue,
  uploadButtonText,
  uploadDescription,
  inputRef,
  items,
  timeById,
  player,
  onUploadClick,
  onFilesChange,
  onTimeChange,
  onTimeBlur,
  onPlayClick,
  onRemoveClick,
  onRetryClick,
  onReorder,
}) => {
  const isDragHandleVisible = items.length > 1;

  return (
    <div className={styles.root}>
      <Button
        elementId={ELEMENT_IDS.uploadButton}
        type={ButtonType.SECONDARY}
        onClick={onUploadClick}>
        {uploadButtonText}
      </Button>

      <input
        ref={inputRef}
        data-testid={ELEMENT_IDS.uploadInputTestId}
        type="file"
        multiple
        accept={acceptValue}
        className={styles.fileInputNative}
        onChange={onFilesChange}
      />

      <p className={styles.description}>{uploadDescription}</p>
      {items.length > 0 && <p className={styles.exactTimeHint}>{TEXTS.EXACT_TIME_HINT}</p>}

      <ReactSortable<PromoUploadStatusType & { id: string }>
        tag="ul"
        list={items as (PromoUploadStatusType & { id: string })[]}
        handle={`.${itemStyles.dragHandle}`}
        disabled={!isDragHandleVisible}
        setList={onReorder}
        className={styles.list}>
        {items.map((item) => (
          <ExactTimeMediaUploaderItem
            key={item.id || item.file?.name || item.title || item.filename || ''}
            item={item}
            mediaType={mediaType}
            time={timeById[item.id || '']}
            player={player}
            isDragHandleVisible={isDragHandleVisible}
            onTimeChange={onTimeChange}
            onTimeBlur={onTimeBlur}
            onPlayClick={onPlayClick}
            onRemoveClick={onRemoveClick}
            onRetryClick={onRetryClick}
          />
        ))}
      </ReactSortable>
    </div>
  );
};

export default ExactTimeMediaUploader;
